function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 36,
  height: 36,
  rx: 8,
  fill: "#F2BBBB"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M22.1625 12.375H13.8375C13.0298 12.375 12.375 13.0298 12.375 13.8375V23.5125C12.375 24.3202 13.0298 24.975 13.8375 24.975H22.1625C22.9702 24.975 23.625 24.3202 23.625 23.5125V13.8375C23.625 13.0298 22.9702 12.375 22.1625 12.375Z",
  stroke: "#7A2C2C",
  strokeWidth: 1.3
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M15.75 11.0249V13.7249M20.25 11.0249V13.7249",
  stroke: "#7A2C2C",
  strokeWidth: 1.3,
  strokeLinecap: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M15.3 16.875H20.7M15.3 19.125H20.7M15.3 21.375H18.675",
  stroke: "#7A2C2C",
  strokeWidth: 1.3,
  strokeLinecap: "round"
});

function SvgSecFilings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecFilings);
export default __webpack_public_path__ + "static/media/sec-filings.d3508feb.svg";
export { ForwardRef as ReactComponent };